export enum ActionTypesPickYourOwnColor {}

export enum MutationTypesPickYourOwnColor {
  SET_OPEN_COLOR_PICKER = "SET_OPEN_COLOR_PICKER",
  SET_SWATCHES = "SET_SWATCHES",
  ADD_SWATCH = "ADD_SWATCH",
  REMOVE_SWATCH = "REMOVE_SWATCH",
  SET_IS_REMOVING = "SET_IS_REMOVING",
}

export enum ActionTypesPickYourOwnColor {
  LOAD_COLORS = "LOAD_COLORS",
  SAVE_COLORS = "SAVE_COLORS",
}
